// Menus & Header Images

// Others
import calender from "../assets/images/calender.png";
import logo from "../assets/images/logo.png";
import logoWhite from "../assets/images/logo-white.png";
import edit from "../assets/images/editIcon.png";
import deleted from "../assets/images/deleteIcon.png";
import copy from "../assets/images/copy.png";
import user from "../assets/images/user.png";
import search from "../assets/images/search.png";
import notification from "../assets/images/notification.png";
import arrow from "../assets/images/arrow.png";
import arrow1 from "../assets/images/arrow1.png";
import noRecord from "../assets/images/noRecord.png";
import exportFile from "../assets/images/exportFile.png";
import close from "../assets/images/close-icon.png";
import documnetexport from "../assets/images/document-export.svg";
import rightclick from "../assets/images/righttike-white.png";
import upload_imag from "../assets/images/uploadDocsIcon_v2.png";
import ImageIcon from "../assets/images/img-icon.png";
import mingcuteUpload from "../assets/images/mingcute--upload-2-line.png";
import unauthorize from "../assets/images/unauthorized.png";

export const AppIcons = {

  // Menus & Header Images

  // Others
  ImageIcon: ImageIcon,
  calenderIcon: calender,
  logoImage: logo,
  logoImageLight:logoWhite,
  editIcon: edit,
  deleteIcon: deleted,
  copyIcon: copy,
  userIcon: user,
  searchIcon: search,
  notificationIcon:notification,
  arrowIcon:arrow,
  arrowIcon1:arrow1,
  noRecordImg:noRecord,
  documnetexportIcon:documnetexport,
  exportIcon:exportFile,
  closeIcon:close,
  rightclick:rightclick,
  upload_imag:upload_imag,
  mingcuteUpload:mingcuteUpload,
  unauthorizedImg: unauthorize 
};
